
import { getOnlineuser, outUser } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigOnlineuser extends Vue {
  private privilege: objAny = {};
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("onlineuser.userFullName"),
      key: "userFullName",
      minWidth: 100
    },
    {
      title: i18n.t("user.userName"),
      key: "userName",
      sortable: true,
      minWidth: 100
    },
    {
      title: i18n.t("onlineuser.ipAddress"),
      key: "ipAddress",
      minWidth: 120
    },
    {
      title: i18n.t("onlineuser.loginTime"),
      key: "loginTime",
      minWidth: 160
    },
    {
      title: "Token",
      key: "token",
      minWidth: 180
    },
    {
      title: i18n.t("operation"),
      key: "resultDes",
      width: 80,
      slot: "action"
    }
  ];
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getOnlineuser(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public userOut(item: objAny): void {
    this.outUser(item);
  }
  async outUser(item: objAny): Promise<void> {
    const ret = await outUser({
      offlineToken: item.token,
      offlineUserName: item.userName
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  mounted() {
    this.privilege = this.$route.meta.privilegeVoObj;
    this.getTableList();
  }
}
